var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"plan-badge-button",class:['plan-badge', { 'plan-badge-selected': _vm.selected }],style:(_vm.badgeStyle),on:{"click":function($event){_vm.$emit('click')}}},[_c('strong',[_vm._v(_vm._s(_vm.plan)+": "+_vm._s(_vm.count))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d62ac1f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/DistributionButton.vue
// module id = null
// module chunks = 